/*  iceberg-ui  */
import { Card, Flex } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Divider } from '@mui/material';

/* Shared */
import { PageTitle } from 'application/Shared/Components/App';
import { Breadcrumbs } from 'application/Shared/Components/App/Breadcrumbs';

/*  Hooks  */
import { useFetchTenantSetting } from 'hooks/dataAccess/Tenant/tenantSetting';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { getReportConfigByType } from '../helpers';
import { HeaderActionsSetupReportOrPrint } from './HeaderActionsSetupReportOrPrint';

export const ReportPageHeader = ({
    noData,
    setupReportView,
    showActions,
    openNavigationFlyout,
    openEditFlyout
}: {
    noData?: boolean;
    setupReportView: boolean;
    showActions?: boolean;
    openNavigationFlyout?: () => void;
    openEditFlyout?: () => void;
}) => {
    const { t } = useTranslation();
    const { clientId, reportType } = useParams();
    const reportConfig = getReportConfigByType(reportType!);
    const { setup } = reportConfig || {};
    const { canBeShownAtPartnerLevel } = setup || {};

    const { setting: qbrToCBR } = useFetchTenantSetting({
        clientId,
        key: 'qbrToCBR'
    });

    // To show "CBR" (Customer Business Review) instead of "QBR" (Quarterly Business Report) when enabled
    const reportName = reportType === 'qbr' && qbrToCBR ? 'cbr' : reportType;

    const breadcrumbAvailablePartnerReportsPath = canBeShownAtPartnerLevel
        ? '/reports/adminReportSelection'
        : '/reports/partnerReportSelection';

    const breadcrumbAvailableReportsPath = clientId
        ? '/reports/reportSelection'
        : breadcrumbAvailablePartnerReportsPath;

    const exportedReportBreadbrumbsPath = [
        {
            key: 'availableReports',
            label: t('Reports.availableReports'),
            route: breadcrumbAvailableReportsPath
        },
        {
            key: 'reportSetup',
            label: t(`Reports.Title.${reportName}.report.setup`),
            route: `/reports/${reportType}`
        },
        ...(!setupReportView
            ? [
                  {
                      key: 'exportedReport',
                      label: t(`Reports.exportedReport`),
                      route: ' '
                  }
              ]
            : [])
    ];

    return (
        <Card
            className="no-print"
            data-testid="reportPageHeader"
            sx={{
                border: 'none',
                borderRadius: 0,
                marginBottom: '24px',
                marginLeft: '-16px',
                marginRight: '-16px',
                marginTop: '-16px',
                paddingX: '24px',
                paddingY: '16px'
            }}
        >
            <PageTitle title={t(`Reports.Title.${reportName}.report`)} />
            <Flex alignItems="center" justifyContents="space-between">
                <Breadcrumbs breadcrumbPath={exportedReportBreadbrumbsPath} />
                {showActions && (
                    <>
                        <Divider
                            sx={{
                                borderColor: 'border.primary',
                                marginBottom: '16px',
                                marginTop: '16px'
                            }}
                        />
                        <HeaderActionsSetupReportOrPrint
                            noData={noData}
                            openNavigationFlyout={openNavigationFlyout}
                            openEditFlyout={openEditFlyout}
                        />
                    </>
                )}
            </Flex>
        </Card>
    );
};
